// extracted by mini-css-extract-plugin
export default {"divColumnStyle":"ResultsModal_divColumnStyle__vZYko","divRowStyle":"ResultsModal_divRowStyle__gTRhV"};